import React from "react";
import { Header } from "./Header";
import { KontentNavigationItem, NavigationItem } from "../../../types";
import { KontentSiteFrameHeader } from "../../../types/index";
import { formatImages } from "../../../lib/images";
import { formatLinks, getLink } from "../../../lib/links";
import { PageProps } from "gatsby";
import { formatLoginForms } from "../../../lib/formatLoginForms";

export interface HeaderProps {
  header: KontentSiteFrameHeader;
  readonly location: PageProps["location"];
}

export function formatNavigation(
  navItem: KontentNavigationItem,
  currentUrl: string
): NavigationItem {
  const formattedLinks = formatLinks(
    navItem.elements?.link_configuration__link?.modular_content
  );
  const link = formattedLinks[0];
  return {
    active: currentUrl !== "/" && link?.href?.startsWith(currentUrl),
    title: navItem.elements?.title?.value,
    link: {
      id: navItem.id,
      label: link?.label,
      href: link?.href,
      target: link?.target,
    },
    subnavigation: navItem.elements?.sub_navigation?.value?.map((subitem) =>
      formatNavigation(subitem, currentUrl)
    ),
  };
}

const HeaderContainer: React.FC<HeaderProps> = ({ header, location }) => {
  const logo = formatImages(header?.elements?.logo?.value[0]?.elements);
  const style = header?.elements?.style?.value[0]?.codename;
  const navigation: NavigationItem[] = header?.elements?.navigation?.value.map(
    (navItem) => formatNavigation(navItem, location?.pathname)
  );
  const secondaryNavLinks =
    formatLinks(header?.elements?.link_configuration__link?.modular_content) ||
    [];
  const secondaryNavigation = secondaryNavLinks.map((link) => {
    return {
      title: link.label,
      link: {
        ...link,
      },
    };
  });

  const forms = formatLoginForms(header?.elements?.login_forms);

  return (
    <Header
      id={header?.system?.id}
      logo={logo.largeImage?.item}
      style={style}
      navigation={navigation}
      secondaryNavigation={secondaryNavigation}
      forms={forms}
    ></Header>
  );
};

export default HeaderContainer;
